import firmaPkDeclaImage from '../../../imagenes/firma-pk-decla.png';
import { fmtDateLongEn, safe } from '../../documentos/commercialExcelUtils';
import { PK_DECLA_SIGNATURE } from './pkDeclaStaticContent';

const FONT = { name: 'Arial', size: 8 };

async function imageUrlToDataUrl(url, mimeType = 'image/png') {
  const response = await fetch(url);
  if (!response.ok) throw new Error('No se pudo cargar la firma PK Decla.');
  const bytes = new Uint8Array(await response.arrayBuffer());
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
  return `data:${mimeType};base64,${btoa(binary)}`;
}

function setFooterCell(cell, value, align = 'left') {
  cell.value = value;
  cell.font = FONT;
  cell.alignment = { vertical: 'top', horizontal: align, wrapText: true };
}

/**
 * Pie Excel (plantilla): fila Signed + fecha; fila siguiente PALM TRADE CHILE + firma.
 * @returns {number} siguiente fila libre
 */
export async function writePkDeclaFooter(ws, wb, startRow, issueDateIso) {
  const r = startRow;
  ws.getRow(r).height = 14;

  setFooterCell(ws.getCell(r, 1), 'Signed');
  setFooterCell(ws.getCell(r, 4), 'date of issue ');

  ws.mergeCells(r, 5, r, 6);
  setFooterCell(
    ws.getCell(r, 5),
    fmtDateLongEn(issueDateIso) || safe(issueDateIso),
    'center'
  );

  const sigBase64 = await imageUrlToDataUrl(firmaPkDeclaImage);
  const signatureId = wb.addImage({ base64: sigBase64, extension: 'png' });
  ws.addImage(signatureId, {
    tl: { col: 2.15, row: r - 1 + 0.02 },
    ext: { width: 100, height: 34 },
    editAs: 'oneCell',
  });

  const rCompany = r + 1;
  ws.getRow(rCompany).height = 11;
  setFooterCell(ws.getCell(rCompany, 2), PK_DECLA_SIGNATURE);

  return rCompany + 1;
}

export function drawPkDeclaFooterPdf(doc, y, issueDateIso) {
  const issueText = fmtDateLongEn(issueDateIso) || safe(issueDateIso);
  const rowY = y;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('Signed', 14, rowY);

  doc.text(PK_DECLA_SIGNATURE, 38, rowY);

  const sigW = 38;
  const sigH = 14;
  doc.addImage(firmaPkDeclaImage, 'PNG', 72, rowY - 3, sigW, sigH);

  doc.text('date of issue ', 118, rowY);
  doc.text(issueText, 148, rowY);

  return rowY + sigH + 4;
}

export { firmaPkDeclaImage };
